// 简体中文
export default {
    /* 登录、注册 =======================================================0 */
    "登录": "登录",
    "注册": "注册",
    "忘记密码": "忘记密码?",
    "没有账号？马上注册": "没有账号？马上注册",
    "请输入手机号": "请输入手机号",
    "请输入密码": "请输入密码",
    "请确认密码": "请确认密码",
    "请输入邀请码": "请输入邀请码",
    "密码确认失败，请重新设置": "密码确认失败，请重新设置",
    "登录中...": "登录中...",
    "登录成功": "登录成功",
    "注册中...": "注册中...",
    "注册成功,即将跳转首页": "注册成功,即将跳转首页",
    "我已经知晓并同意开户协议各项条约": "我已经知晓并同意开户协议各项条约",
    "请阅读并同意开户协议": "请阅读并同意开户协议",
    "已有账号？马上登录": "已有账号？马上登录",
    "请联系在线客服": "请联系在线客服",
    /* 登录、注册 =======================================================1 */

    /* 首页 ============================================================0 */
    "首页": "首页",
    "请选择地区": "请选择地区",
    "全国第一福利品": "全国第一福利品",
    "为了会员权益，网站只展示 1% 资源并且不定期更新只为展示实力，如需查询预约更多资源请联系上级接待": "为了会员权益，网站只展示 1% 资源并且不定期更新只为展示实力，如需查询预约更多资源请联系上级接待",
    "本平台所有资源真实、安全、可靠，全国空降、同城约炮选取你心仪的她，与您零距离邂逅，快加入我们吧": "本平台所有资源真实、安全、可靠，全国空降、同城约炮选取你心仪的她，与您零距离邂逅，快加入我们吧!",
    "平台资源": "平台资源",
    "昵称": "昵称:",
    "类型": "类型:",
    "距离：点击查看": "距离：点击查看",
    "服务项目：激活可见": "服务项目：激活可见",
    "已认证": "已认证",
    "查看更多": "查看更多",
    "当前地区暂无资源": "当前地区暂无资源",
    "服务条款": "服务条款",
    "网红、模特、空姐、嫩模、大学生、留学生，只有您想不到，没有本平台办不到": "网红、模特、空姐、嫩模、大学生、留学生，只有您想不到，没有本平台办不到。",
    "服务范围": "服务范围",
    "同城约炮，任意地点空降，国内一二线城市当地均有，三线城市也可以通过上级预约安排": "同城约炮，任意地点空降，国内一二线城市当地均有，三线城市也可以通过上级预约安排。",
    "热门地区": "热门地区",
    "更多地区": "更多地区",
    "网红、模特、空姐、嫩模、大学生、留学生": ['网红', '模特', '空姐', '嫩模', '大学生', '留学生'],
    "请联系管理员激活账号": "请联系管理员激活账号",
    "请联系客服获取更多信息": "请联系客服获取更多信息",
    /* 首页 ============================================================1 */

    /* 福利 ============================================================0 */
    "福利": "福利",
    "全部": "全部",
    /* 福利 ============================================================1 */

    /* 视频 ============================================================0 */
    "视频": "视频",
    /* 视频 ============================================================1 */

    /* 我的 ============================================================0 */
    "我的": "我的",
    "余额": "余额",
    "元": "元",
    "¥": "¥",
    "CNY": "CNY",
    "我的信用分": "我的信用分",
    "我的客服": "我的客服",
    "提现": "提现",
    "提现记录": "提现记录",
    "个人报表": "个人报表",
    "任务记录": "任务记录",
    "我的消息": "我的消息",
    "银行卡": "银行卡",
    "设置": "设置",
    "未配置跳转链接": "未配置跳转链接",
    "功能尚未开放": "功能尚未开放",
    /* 我的 ============================================================1 */

    /* 美女 ============================================================0 */
    "公告": "公告",
    "基本信息": "基本信息",
    "生日": "生日: ****年**月**日",
    "身高": "身高: ***cm",
    "体重": "体重: ***kg",
    "胸围": "胸围: ***",
    "所在位置：已隐藏，联系客服激活可见": "所在位置：已隐藏，联系客服激活可见。",
    "联系方式：已隐藏，联系客服激活可见": "联系方式：已隐藏，联系客服激活可见。",
    "服务项目：激活可见": "服务项目：激活可见。",
    "祝愿各位会员每天都能遇到美好的恋情，享受快乐的夜晚": "祝愿各位会员每天都能遇到美好的恋情，享受快乐的夜晚!",
    "立即约她": "立即约她",
    "联系专属客服接待": "联系专属客服接待",
    /* 美女 ============================================================1 */

    /* 个人报表 ========================================================0 */
    "盈利金额": "盈利金额",
    "盈利计算公式": "盈利计算公式",
    "任务金额": "任务金额",
    "充值金额": "充值金额",
    "提现金额": "提现金额",
    "中奖金额": "中奖金额",
    /* 个人报表 ========================================================1 */

    /* 播放器 ==========================================================0 */
    "播放器": "播放器",
    "热门推荐": "热门推荐",
    "提示": "提示",
    "播放次数已用完，请联系专属客服": "播放次数已用完，请联系专属客服",
    /* 播放器 ==========================================================1 */

    /* 下注 ===========================================================0 */
    "彩票": "彩票",
    "查看历史开奖": "查看历史开奖",
    "开奖期数": "开奖期数",
    "中奖号码": "中奖号码",
    "下单": "下单",
    "下注号码": "下注号码",
    "请选择下注号码": "请选择下注号码",
    "每注金额": "每注金额",
    "请输入金额": "请输入金额",
    "总计": "总计",
    "订单": "订单",
    "清空": "清空",
    "余额不足，请联系客服充值": "余额不足，请联系客服充值",
    "付款功能未开通，请联系在线客服": "付款功能未开通，请联系在线客服",
    "付款中...": "付款中...",
    "付款成功": "付款成功",
    /* 下注 ===========================================================1 */

    /* 任务记录 =======================================================0 */
    "暂无记录": "暂无记录",
    "待开奖": "待开奖",
    "订单金额": "订单金额:",
    "中奖金额": "中奖金额:",
    "下注时间": "下注时间:",
    "开奖时间": "开奖时间:",
    "隐藏详情": "隐藏详情",
    "查看详情": "查看详情",
    "投注号码": "投注号码:",
    "投注金额": "投注金额:",
    /* 任务记录 =======================================================1 */

    /* 银行卡 =========================================================0 */
    "银行名称": "银行名称",
    "银行卡号": "银行卡号",
    "持卡人姓名": "持卡人姓名",
    "手机号": "手机号",
    "点击选择银行": "点击选择银行",
    "请填写银行卡号": "请填写银行卡号",
    "请填写持卡人姓名": "请填写持卡人姓名",
    "请填写预留手机号": "请填写预留手机号",
    "添加银行卡": "添加银行卡",
    "绑定银行卡": "绑定银行卡",
    "提示:请绑定大型商业银行, 如需修改, 请您联系在线客服": "提示:请绑定大型商业银行, 如需修改, 请您联系在线客服。",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款。",
    "请绑定大型商业银行, 如需修改, 请您联系在线客服": "请绑定大型商业银行, 如需修改, 请您联系在线客服。",
    /* 银行卡 =========================================================1 */

    /* 提现 ===========================================================0 */
    "记录": "提现记录",
    "限额说明": "限额说明",
    "单笔交易最低限额": "单笔交易最低限额",
    "单笔交易最高限额": "单笔交易最高限额",
    "每天可提款次数": "每天可提款次数",
    "到账时间": "到账时间：一般在 5 分钟左右，但最快可达 2 分钟。",
    "请输入资金密码": "请输入资金密码",
    "请联系专属客服": "请联系专属客服",
    "取消": "取消",
    "提交中...": "提交中...",
    "说明": "说明",
    "提交时间": "提交时间",
    "审核时间": "审核时间",
    "审核中": "审核中",
    "请设置提现密码以及绑定银行卡，否则无法使用提现功能": "请设置提现密码以及绑定银行卡，否则无法使用提现功能",
    "设置提现密码": "设置提现密码",
    "返回": "返回",
    "请绑定银行卡，否则无法使用提现功能": "请绑定银行卡，否则无法使用提现功能",
    "绑定银行卡": "绑定银行卡",
    /* 提现 ===========================================================1 */

    /* 设置 ===========================================================0 */
    "头像": "头像",
    "点击选择头像": "点击选择头像",
    "姓名": "姓名",
    "点击设置姓名": "点击设置姓名",
    "性别": "性别",
    "男": "男",
    "女": "女",
    "未知": "未知",
    "点击选择性别": "点击选择性别",
    "登录密码": "登录密码",
    "去修改": "去修改",
    "资金密码": "资金密码",
    "如需修改，请联系专属客服": "如需修改，请联系专属客服",
    "设置动词": "设置",
    "语言": "语言",
    "切换语言": "切换语言",
    "退出登录": "退出登录",
    "选择头像": "选择头像",
    "确定": "确定",
    "设置姓名": "设置姓名",
    "请输入您的姓名": "请输入您的姓名",
    "请选择您的性别": "请选择您的性别",
    "你已设置姓名，如需修改，请联系专属客服": "你已设置姓名，如需修改，请联系专属客服。",
    /* 设置 ===========================================================1 */

    /* 选择语言 ===========================================================0 */
    "选择语言": "选择语言",
    "正在切换语言...": "正在切换语言...",
    /* 选择语言 ===========================================================1 */

    /* 修改登录密 =========================================================0 */
    "修改登录密码": "修改登录密码",
    "旧密码": "旧密码",
    "请输入旧密码": "请输入旧密码",
    "新密码": "新密码",
    "请输入新密码": "请输入新密码",
    "确认密码": "确认密码",
    "请确认新密码": "请确认新密码",
    "修改": "修改",
    "修改中...": "修改中...",
    "修改成功，请重新登录": "修改成功，请重新登录",
    /* 修改登录密 =========================================================1 */

    /* 设置资金密码 =======================================================1 */
    "设置资金密码": "设置资金密码",
    "资金密码必须由四位数字组成": "资金密码必须由四位数字组成",
    "设置中...": "设置中...",
    "设置成功": "设置成功",
    /* 设置资金密码 =======================================================1 */
}